<a
  tabindex="0"
  [cPopover]="popoverHtml"
  [cPopoverPlacement]="menuPlacement"
  [cPopoverTrigger]="['click']"
  [cPopoverVisible]="false"
  class="cil-options menu-icon flex flex-center-main full-height flex-center-cross">
  <ng-template #popoverHtml>
    <div cListGroup class="aggrid-popover">
      @for (menu of menuList; track menu.key) {
        <button cListGroupItem (click)="onClick(menu.key)">
          {{ menu.value }}
        </button>
      }
    </div>
  </ng-template>
</a>
